import React from "react";
import { View } from "react-native";

const ManualCoordinatesInput: React.FC<any> = () => {
  return <View />;
};

export default ManualCoordinatesInput;
